import { createSlice } from "@reduxjs/toolkit";

const OnlineOrderSlice = createSlice({
  name: "onlineOrder",
  initialState: {
    loading: false,
    data: null,
    verifyData: null,
    error: null,
  },

  reducers: {
    createOnlineOrderRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    createOnlineOrderSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    createOnlineOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    verifyOnlineOrderRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    verifyOnlineOrderSuccess: (state, action) => {
      state.loading = false;
      state.verifyData = action.payload;
    },
    verifyOnlineOrderFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    resetOnlineOrderState: (state) => {
      state.loading = false;
      state.data = null;
      state.verifyData = null;
      state.error = null;
    },
  },
});

export const {
  createOnlineOrderRequest,
  createOnlineOrderSuccess,
  createOnlineOrderFailure,
  verifyOnlineOrderRequest,
  verifyOnlineOrderSuccess,
  verifyOnlineOrderFailure,
  resetOnlineOrderState,
} = OnlineOrderSlice.actions;

export default OnlineOrderSlice.reducer;
